// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardAccumulatorModel {
    static getAttributeTypeMap() {
        return CardAccumulatorModel.attributeTypeMap;
    }
}
CardAccumulatorModel.discriminator = undefined;
CardAccumulatorModel.additionalProperties = false;
CardAccumulatorModel.attributeTypeMap = [
    {
        "name": "medications",
        "baseName": "medications",
        "type": "Array<CardMedicationModel>"
    },
    {
        "name": "medicationMaxBenefit",
        "baseName": "medicationMaxBenefit",
        "type": "number"
    },
    {
        "name": "remaingMedicationBenefit",
        "baseName": "remaingMedicationBenefit",
        "type": "number"
    },
    {
        "name": "totalMedicationPaid",
        "baseName": "totalMedicationPaid",
        "type": "number"
    },
];
//# sourceMappingURL=cardAccumulatorModel.js.map